module.exports = __webpack_public_path__ + "static/media/checkedicon.e5fd48c7.svg";